import Tooltip from "src/components/Tooltip/Tooltip";
import Info from "src/design-system/icons/Info.svg?react";
import { tw } from "src/design-system/tw";

export type RadioLabelProps = {
  radioLabel: string;
  radioSecondaryText?: string;
  tooltip?: string;
  isSelected?: boolean;
};

export function RadioLabel({
  radioLabel,
  radioSecondaryText,
  tooltip,
  isSelected,
}: RadioLabelProps) {
  return (
    <div className="flex shrink-0 grow basis-0 items-center justify-between gap-3">
      <span
        className={tw(
          "inline-flex items-center gap-md text-label-lg text-text-primary",
          isSelected && "font-bold",
        )}
      >
        {radioLabel}
        {tooltip && (
          <Tooltip
            id={`${radioLabel}-tooltip`}
            anchor="left"
            placement="bottom"
            tooltipContent={
              <p className="max-w-62 p-4 text-sm leading-tight">{tooltip}</p>
            }
            className="flex text-icon-secondary hover:text-icon-secondary-hover"
            placementOffset={5}
            anchorOffset={-18}
            showOnMobileFocus
          >
            <Info className="h-5 w-5 text-icon-secondary" />
          </Tooltip>
        )}
      </span>
      {radioSecondaryText && (
        <span className="text-label-md text-text-secondary">
          {radioSecondaryText}
        </span>
      )}
    </div>
  );
}
